function beforesubmitShopLogin(){
    valid = true;
    if(document.getElementById('binreg') && document.getElementById('binreg').checked == true){
        if(document.f.usr.value == '' || document.f.pwd.value == ''){
            displayErrorBox(cpText.shop_login_usr_pwd_befuellen);
            valid = false;
        }else{
            $.ajax({
                url:ABSOLUTE_WEBPATH + 'cmshx_template/ajax/login.php',
                data:$("form").serialize(),
                type:"POST",
                async: false,
            }).done(function(id_k){
                if(id_k == "0"){
                    displayErrorBox(cpText.shop_login_inkorrekt);
                    valid =  false;
                }
            });
        }
    }else if(document.getElementById('jezreg').checked == true){
        document.f.reg.value = 1;
    }else if(document.getElementById('nichtreg').checked == true){
        document.f.reg.value = 0;
    }else{
        displayErrorBox(cpText.shop_login_bitte_waehlen);
        valid =  false;
    }
    return valid;
}

function beforesubmitShopPwReq(){
    if(document.getElementById('email').value == '' || check_email(document.getElementById('email').value) == false){
        displayErrorBox(cpText.shop_form_email_ungueltig);
        return false;
    }
    return true;
}

function beforesubmitShopPageEvent(){
    valid = true;

    if(valid && document.f.event_tag.value == '' || document.f.event_monat.value == '' || document.f.event_jahr.value == ''){
        displayErrorBox(cpText.form_bitte_befuellen + " " + cpText.shop_eventdatum);
        document.f.event_tag.focus();
        valid = false;
    }

    if(valid && document.f.event_stunde.value == '' || document.f.event_minute.value == ''){
        displayErrorBox(cpText.form_bitte_befuellen + " " + cpText.shop_eventuhrzeit);
        document.f.event_stunde.focus();
        valid = false;
    }

    if(valid && document.f.eventort.value == ''){
        displayErrorBox(cpText.form_bitte_befuellen + " " + cpText.shop_eventort);
        document.f.eventort.focus();
        valid = false;
    }
    if(valid && document.f.eventplz.value == ''){
        displayErrorBox(cpText.form_bitte_befuellen + " " + cpText.shop_form_plz);
        document.f.eventplz.focus();
        valid = false;
    }
    if(valid && document.f.id_shop_bundesland.options.selectedIndex == 0){
        displayErrorBox(cpText.form_bitte_befuellen + " " + cpText.shop_form_bundesland);
        document.f.id_shop_bundesland.focus();
        valid = false;
    }

    if(valid){
        $.ajax({
            url:ABSOLUTE_WEBPATH + 'cmshx_template/ajax/event.php',
            data:$("form").serialize(),
            type:"POST",
            async: false,
        }).done(function(response){
            if(response == 0){
                displayErrorBox(cpText.shop_event_2at);
                document.f.event_jahr.focus();
                valid = false;
            }
        })
        return valid;
    }else{
        return false;
    }
}

function beforesubmitShopPageKorb(step){
    if(check_korb() == true) return true;
    document.f.step.value = step;
    return false;
}

function add2cart(anz, url){
    if(anz == 0){
        document.location.href = url;
    }else{
        displayConfirmBox(cpText.shop_korb_wird_gelehrt, url)
    }
}

function beforesubmitShopReg(){
    if(document.f.pwd.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_passwort);
        document.f.pwd.focus();
        return false;
    }

    if(document.f.pwd.value.length < 6){
        displayErrorBox(cpText.shop_form_passwort_zu_kurz);
        document.f.pwd.focus();
        return false;
    }

    if(document.f.pwdw.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_passwortw);
        document.f.pwdw.focus();
        return false;
    }

    if(document.f.pwd.value != document.f.pwdw.value){
        displayErrorBox(cpText.shop_form_passwort_nicht_ident);
        document.f.pwdw.focus();
        return false;
    }

    return true;
}

function beforesubmitShopRa(){
    valid = true;
    if(valid && document.f.anrede.options.selectedIndex == 0){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_anrede);
        document.f.anrede.focus();
        valid = false;
    }
    if(valid && document.f.vorname.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_vorname);
        document.f.vorname.focus();
        valid = false;
    }
    if(valid && document.f.nachname.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_nachname);
        document.f.nachname.focus();
        valid = false;
    }
    if(valid && document.f.adresse.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_adresse);
        document.f.adresse.focus();
        valid = false;
    }
    if(valid && document.f.plz.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_plz);
        document.f.plz.focus();
        valid = false;
    }
    if(valid && document.f.ort.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_ort);
        document.f.ort.focus();
        valid = false;
    }
    if(valid && document.f.id_shop_bundesland.options.selectedIndex == 0){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_bundesland);
        document.f.id_shop_bundesland.focus();
        valid = false;
    }
    if(valid && document.f.telefon.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_telefon);
        document.f.telefon.focus();
        valid = false;
    }
    if(valid && document.f.email.value == ''){
        displayErrorBox(cpText.shop_form_bitte_befuellen + " " + cpText.shop_form_email);
        document.f.email.focus();
        valid = false;
    }

    if(valid && hx.isValidEmailAddress(document.f.email.value) == false){
        displayErrorBox(cpText.shop_form_email_ungueltig);
        document.f.email.focus();
        valid = false;
    }

    if(valid){
        $.ajax({
            url:ABSOLUTE_WEBPATH + 'cmshx_template/ajax/emailunique.php',
            data:$("form").serialize(),
            type:"POST",
            async: false,
        }).done(function(response){
            if(response == 'exists'){
                displayErrorBox(cpText.event_konto_form_email_exists);
                document.f.email.focus();
                valid = false;
            }
        });
        return valid;
    }else{
        return false;
    }
}

function beforesubmitShopPageKundenDaten(reg){
    if(beforesubmitShopRa() == false) return false;
    if(reg == 1 && beforesubmitShopReg() == false) return false;
    return true;
}

$(document).on("click", ".js-beforesubmitShopPageKorb-trigger", function(e){
    document.f.step.value=''
    e.preventDefault();
    $(".js-formShopPageKorb").submit();
})

$(document).on("submit", ".js-form-anfrage", function(){
   displayLoader();
});